function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.0731 7.39127C17.0731 10.9703 14.2034 13.8401 10.6219 13.8401C7.04157 13.8401 4.17072 10.9703 4.17072 7.39127C4.17072 3.81225 7.04157 0.943665 10.6219 0.943665C14.2034 0.943665 17.0731 3.81225 17.0731 7.39127ZM10.6217 25.3154C5.33597 25.3154 0.873047 24.4563 0.873047 21.1417C0.873047 17.8259 5.364 16.9973 10.6217 16.9973C15.9087 16.9973 20.3704 17.8564 20.3704 21.171C20.3704 24.4868 15.8795 25.3154 10.6217 25.3154Z",
  fill: "#B8D2FF"
});

function SvgProfileLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLight);
export default __webpack_public_path__ + "static/media/profile-light.46ca0b9d.svg";
export { ForwardRef as ReactComponent };